import { render } from "./ContactM.vue?vue&type=template&id=904b8766&scoped=true"
import script from "./ContactM.vue?vue&type=script&lang=js"
export * from "./ContactM.vue?vue&type=script&lang=js"

import "./ContactM.vue?vue&type=style&index=0&id=904b8766&lang=scss&scoped=true"

import exportComponent from "E:\\vueWeb\\official\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-904b8766"]])

export default __exports__